const registrationStepper = document.querySelectorAll('.section account-page-forms-registration');



$(document).ready(function(){


    $("#previous-1").on('click', function(){		
		$('.form-error-information').html("");
       $('#stepTwo').hide();
       $("#stepOne").show();
       $(".stepNumber").html("1");
       $('#BillingInfo').removeClass("design-tool__step-info active");
       $('#BasicInfo').addClass("design-tool__step-info hidden");
       $('#BasicInfo').addClass("design-tool__step-info active")
       $("#step1").removeClass("design-tool__step complete");
       $("#step1").addClass("design-tool__step active");
       $("#step2").removeClass("design-tool__step active");
       $("#step2").addClass("design-tool__step");   
	   $('.form-error-information').html("");
    });   

//Step Two Sytles 

    $("#previous-3").click(function(){		
	  $('.form-error-information').html("");
      $("#stepThree").hide();
      $('#stepTwo').show();
      $(".stepNumber").html("2");
      $('#ShippingInfo').removeClass("design-tool__step-info active");
      $('#ShippingInfo').addClass("design-tool__step-info hidden");
      $('#BillingInfo').addClass("design-tool__step-info active");
      $("#step3").removeClass("design-tool__step active");
      $("#step3").addClass("design-tool__step");
      $("#step2").removeClass("design-tool__step complete");
      $("#step2").addClass("design-tool__step active"); 
	  $('.form-error-information').html("");
    });


//Skip styles on second step
  // $('#skipStep').on('click', function(e){
     // $('#stepTwo').hide();
     // $("#stepThree").show();
     // $(".stepNumber").html("3");
	 // $('#duplicateBilling').val('TRUE');
     // $('#BillingInfo').removeClass("design-tool__step-info active");
     // $('#BillingInfo').addClass("design-tool__step-info hidden");
     // $('#ShippingInfo').addClass("design-tool__step-info active") 
     // $("#step2").removeClass("design-tool__step active");
     // $("#step2").addClass("design-tool__step complete");
     // $("#step2").addClass("design-tool__step check");
     // $("#step3").addClass("design-tool__step active"); 

  // })

});




